
import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getTermCondition(authorization) {
  const url = `${API_URL}/admin/master/toc`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getTermConditionPublic() {
  const url = `${API_URL}/dashboard/auth/toc`;
  return axios({ url,
    method: 'get',
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setTermCondition(content, authorization) {
  const url = `${API_URL}/admin/master/toc/update`;
  return axios({
    url,
    method: 'post',
    data: { content },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/termsofcondition.js